import { useEffect } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import SAISVG, { toAbsoluteUrl } from '../../../helpers/CommonFunction'
import { useLayout } from '../../core/LayoutProvider'
import PageTitle from '../toolbar/page-title/PageTitle'
import DevNavbar from './DevNavbar'

const DevHeaderWrapper = () => {
    useEffect(() => {
        document.body.setAttribute('data-sai-app-header-fixed', 'true')
    }, [])

    const { config, classes } = useLayout()
    if (!config.app?.header?.display) {
        return null
    }
    return (
        <div id='sai_app_header' className='app-header'>
            <div
                id='sai_app_header_container'
                className={clsx(
                    'app-container flex-lg-grow-1',
                    classes.headerContainer.join(' '),
                    config.app?.header?.default?.containerClass
                )}
            >
                {config.app.sidebar?.display && (
                    <>
                        <div
                            className='d-flex align-items-center d-lg-none ms-n2 me-2'
                            title='Show sidebar menu'
                        >
                            <div
                                className='btn btn-icon btn-active-color-primary w-35px h-35px'
                                id='sai_app_sidebar_mobile_toggle'
                            >
                                <SAISVG path='media/icons/duotune/abstract/abs015.svg' className=' svg-icon-1' />
                            </div>
                            <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
                                <Link to='/dashboard' className='d-lg-none'>
                                    <img alt='Logo' src='./assets/media/logos/default-small.svg' className='h-30px' />
                                </Link>
                            </div>
                        </div>
                    </>
                )}

                {!config.app.sidebar?.display && (
                    <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15'>
                        <Link to='/dashboard'>
                            {config.layoutType !== 'dark-header' ? (
                                <img
                                    alt='Logo'
                                    src={toAbsoluteUrl('media/logos/default-dark.svg')}
                                    className='h-20px h-lg-30px app-sidebar-logo-default'
                                />
                            ) : (
                                <>
                                    <img
                                        alt='Logo'
                                        src={toAbsoluteUrl('media/logos/default.svg')}
                                        className='h-20px h-lg-30px app-sidebar-logo-default theme-light-show'
                                    />
                                    <img
                                        alt='Logo'
                                        src={toAbsoluteUrl('media/logos/default-dark.svg')}
                                        className='h-20px h-lg-30px app-sidebar-logo-default theme-dark-show'
                                    />
                                </>
                            )}
                        </Link>
                    </div>
                )}

                <div
                    id='sai_app_header_wrapper'
                    className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'
                >
                    {config.app.header.default?.content === 'menu' &&
                        config.app.header.default.menu?.display && (
                            <div
                                className='app-header-menu app-header-mobile-drawer align-items-stretch'
                                data-sai-drawer='true'
                                data-sai-drawer-name='app-header-menu'
                                data-sai-drawer-activate='{default: true, lg: false}'
                                data-sai-drawer-overlay='true'
                                data-sai-drawer-width='225px'
                                data-sai-drawer-direction='end'
                                data-sai-drawer-toggle='#sai_app_header_menu_toggle'
                                data-sai-swapper='true'
                                data-sai-swapper-mode="{default: 'append', lg: 'prepend'}"
                                data-sai-swapper-parent="{default: '#sai_app_body', lg: '#sai_app_header_wrapper'}"
                            >
                                {/* <Header /> */}
                                <PageTitle />
                            </div>
                        )}
                    <DevNavbar />
                </div>
            </div>
        </div>
    )
}

export default DevHeaderWrapper